import React from "react";
import {connect} from "dva";
import {component_tool, framework_tool, utils_tool} from '../../../tool';

import {WizDataAuthSelect} from '../../common'

let {WizContainer, WizReduxTemplate, modelUtils} = framework_tool;
let {WizCard, WizAntdForm, WizCol, WizButton, WizSpin} = component_tool;
let {Session} = utils_tool

const {Item} = WizAntdForm;

class PermissionsAdd extends WizContainer {
  componentName = 'PermissionsAdd';

  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
    }

    let {history} = this.props;
    if (history.location && history.location.record) {
      this.initialValue = history.location.record
      Session.set('permissionsInfo', this.initialValue)
    } else {
      this.initialValue = Session.get('permissionsInfo') || {}
    }
  }

  _componentWillMount() {

  }

  propsAndStateOnChange = {
    add: this.addHandle.bind(this),
  }

  _render() {
    let  {isLoading} = this.state;
    let {form} = this.props

    return (
      <WizSpin spinning={isLoading}>
      <WizCard title={'批量设置'}>
        <WizAntdForm ref={(form) => this.form = form} labelCol={{span: 6}} wrapperCol={{span: 15}} >
          <Item label={'添加受众'}>
            <WizCol style={{borderWidth: 1, borderColor: '#F0F2F5', borderStyle: 'solid', paddingTop: 20}}>
              {
                form.getFieldDecorator('dataAuth', {initialValue: {}})(
                  <WizDataAuthSelect modalKey={'dataAuth'} hasRadioGroup={false}/>
                )
              }
            </WizCol>
          </Item>
          <Item label={'添加管理范围'}>
            <WizCol style={{borderWidth: 1, borderColor: '#F0F2F5', borderStyle: 'solid', paddingTop: 20}}>
              {
                form.getFieldDecorator('dataManagerAuth', {initialValue: {}})(
                  <WizDataAuthSelect modalKey={'dataManagerAuth'} hasRadioGroup={false}/>
                )
              }
            </WizCol>
          </Item>
          <Item wrapperCol={{span: 12, offset: 6}}>
            <WizButton title="保存" type="primary" htmlType="submit" onClick={this._onSubmit}>保存</WizButton>
          </Item>
        </WizAntdForm>
      </WizCard>
      </WizSpin>
    );
  }

  _onSubmit = (e) => {
    this.setState({
      isLoading: true,
    })

    const {getFieldsValue} = this.props.form;
    let bizList = this.initialValue && this.initialValue.map(data => {
      return {bizType: data.bizType, bizId: data.id}
    }) || []

    let data = getFieldsValue();
    data.dataAuth = this.getDataAuth(data.dataAuth);
    data.dataManagerAuth = this.getDataAuth(data.dataManagerAuth);
    data.bizList = bizList

    this.doAction({
      path: 'permissions/add',
      payload: {
        key: "add",
        apiParams: data,
      }
    })
  }

  getDataAuth(data = {}) {
    let {orgIds, positionIds, positionCategoryIds, personIds} = data;
    let temp = {};

    if (orgIds) {
      temp.orgIds = orgIds.map(tmp => tmp.id);
    }
    if (positionIds) {
      temp.positionIds = positionIds.map(tmp => tmp.id);
    }
    if (positionCategoryIds) {
      temp.positionCategoryIds = positionCategoryIds.map(tmp => tmp.id);
    }
    if (personIds) {
      temp.personIds = personIds.map(tmp => tmp.id);
    }

    return temp;
  }

  addHandle(nextProps, nextState) {
    nextState.isLoading = false;
    if (nextProps.add.code === 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replace', '/permissions/list');
    } else {
      wizNotice.error('提交失败：' + nextProps.add.msg);
    }
    return true;
  }
}

const mapStateToProps = (state, ownProps) => {
  const { permissions } = state;
  const add = modelUtils.getModelEntity(permissions, 'add');
  return {
    add,
  }
};

// export default connect(mapStateToProps)(PermissionsAdd);
export default WizAntdForm.create()(connect(mapStateToProps)(PermissionsAdd));
